<template>
  <section v-if="loaded">
    <div class="compare-button" v-if="selectedItems.length > 0" @click="toCompareTable">
      <div class="d-flex align-items-center">
        <div class="mr-4">
          <img src="../assets/icons/compare.svg"> 
        </div>
        <div class="mr-4">
          <p class="mb-1">{{ $t('Porovnávanie bytov') }}</p>
          <p class="small-text mb-0">{{ $t('Pridané byty:') }} {{selectedItems.length}}</p>
        </div>
        <div>
          <a>{{ $t('Zobraziť') }}</a>
        </div>
      </div>
      <div class="compare-flats-detail border-top w-100 mt-1 pt-1 d-none d-md-block">
        <div v-for="(flat, id) in compare" :key="id" class="row">
          <div class="col">{{ flat.flat_number_of_rooms }} {{ $t('izb.') }}</div>
          <div class="col">{{ flat.flat_penta_internal_id }}</div>
          <div class="col" v-if="flat.flat_penta_internal_id === 'B.06.A'">Cena na vyžiadanie</div>
          <div v-else class="col">{{currency(flat.flat_price)}} €</div>
          <div class="col-2 d-flex justify-content-end"><div class="d-flex align-items-center p-2" @click="removeFromCompare(flatInfo)"><img class="delete-item" width="10" src="../assets/icons/close.svg" alt=""></div></div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-wrap flatDetail px-md-5">
      <FlatHeader
        :flat-info="flatInfo"
        :is-in-compare="isInCompare"
        :compare-count="compare.length"
        @back="backToFlats"
        @add-to-compare="addToCompare(flatInfo)"
        @remove-from-compare="removeFromCompare(flatInfo)"
      />
      <div class="col-md-12">
        <b-tabs
            active-nav-item-class="font-weight-bold"
            active-tab-class="font-weight-bold"
            content-class="mt-3"
            nav-wrapper-class="nav-wrapper"
            @input="tabChange($event)"
            v-model="tabIndex"
        >
          <b-tab :title="$t('Rozloha')" active>
            <div class="row">
              <div class="col-lg-5 pr-md-5 flat-info">
                <div v-if="stage == 'bory5'">
                  <div class="d-flex justify-content-between border-bottom py-2 pr-3">
                    <div class="label">{{ $t('Budova') }}</div>
                    <div v-if="flatInfo.building" class="value">{{flatInfo.building.building_name}}</div>
                  </div>
                  <div class="d-flex justify-content-between border-bottom py-2 pr-3">
                    <div class="label">{{ $t('Vchod') }}</div>
                    <div v-if="flatInfo.building" class="value">{{flatInfo.flat_entrance}}</div>
                  </div>
                </div>
                <div class="d-flex justify-content-between border-bottom py-2 pr-3" v-else>
                  <div class="label">{{ $t('Blok') }}</div>
                  <div v-if="flatInfo.building" class="value">{{flatInfo.building.building_name}}</div>
                </div>
                <div class="d-flex justify-content-between border-bottom py-2 pr-3">
                  <div class="label" v-if="flatInfo.building.building_stage == 'boryNoveBloky'">{{ $t('Poschodie') }}</div>
                  <div class="label" v-else>{{ $t('Podlažie') }}</div>
                  <div v-if="flatInfo.building" class="value">{{flatInfo.building.floor_number}}</div>
                </div>
                <div class="d-flex justify-content-between border-bottom py-2 pr-3">
                  <div class="label">{{ $t('Počet izieb') }}</div>
                  <div class="value">{{flatInfo.flat_number_of_rooms}}</div>
                </div>
                <div class="d-flex justify-content-between border-bottom py-2 pr-3">
                  <div class="label text-uppercase">{{$t('ÚŽITKOVÁ PLOCHA BYTU')}}</div>
                  <div class="value">{{flatInfo.flat_area}} m<sup>2</sup></div>
                </div>
                <div class="border-bottom pl-3 py-2 pr-3">
                  <div class="d-flex justify-content-between pl-5">
                    <div class="label">{{ $t('Kúpeľňa') }}</div>
                    <div class="value">{{flatInfo.flat_area_bathroom1}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_bathroom2" class="d-flex justify-content-between pl-5">
                    <div class="label">{{ $t('Kúpeľňa') }} 2</div>
                    <div class="value">{{flatInfo.flat_area_bathroom2}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_bedroom" class="d-flex justify-content-between pl-5">
                    <div class="label">{{ $t('Spálňa') }}</div>
                    <div class="value">{{flatInfo.flat_area_bedroom}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_corridor1" class="d-flex justify-content-between pl-5">
                    <div class="label">{{$t('Chodba')}}</div>
                    <div class="value">{{flatInfo.flat_area_corridor1}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_corridor2" class="d-flex justify-content-between pl-5">
                    <div class="label">{{$t('Chodba')}} 2</div>
                    <div class="value">{{flatInfo.flat_area_corridor2}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_hall" class="d-flex justify-content-between pl-5">
                    <div class="label">{{$t('Chodba')}}</div>
                    <div class="value">{{flatInfo.flat_area_hall}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_kitchen" class="d-flex justify-content-between pl-5">
                    <div class="label">{{ $t('Kuchyňa') }}</div>
                    <div class="value">{{flatInfo.flat_area_kitchen}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_livingroom_kitchen" class="d-flex justify-content-between pl-5">
                    <div class="label">{{ $t('Obývacia izba + Kuchyňa') }}</div>
                    <div class="value">{{flatInfo.flat_area_livingroom_kitchen}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_livingroom" class="d-flex justify-content-between pl-5">
                    <div class="label">{{ $t('Obývacia izba') }}</div>
                    <div class="value">{{flatInfo.flat_area_livingroom}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_room1" class="d-flex justify-content-between pl-5">
                    <div class="label">{{ $t('Izba') }}</div>
                    <div class="value">{{flatInfo.flat_area_room1}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_room2" class="d-flex justify-content-between pl-5">
                    <div class="label">{{ $t('Izba') }} 2</div>
                    <div class="value">{{flatInfo.flat_area_room2}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_room3" class="d-flex justify-content-between pl-5">
                    <div class="label">Izba 3</div>
                    <div class="value">{{flatInfo.flat_area_room3}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_sleeping_niche" class="d-flex justify-content-between pl-5">
                    <div class="label">{{ $t('Spací výklenok') }}</div>
                    <div class="value">{{flatInfo.flat_area_sleeping_niche}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_cloakroom" class="d-flex justify-content-between pl-5">
                    <div class="label">{{ $t('Šatňa') }}</div>
                    <div class="value">{{flatInfo.flat_area_cloakroom}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_toilette" class="d-flex justify-content-between pl-5">
                    <div class="label">{{ $t('WC') }}</div>
                    <div class="value">{{flatInfo.flat_area_toilette}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_storage" class="d-flex justify-content-between pl-5">
                    <div class="label">{{$t('Sklad')}}</div>
                    <div class="value">{{flatInfo.flat_area_storage}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_laundry" class="d-flex justify-content-between pl-5">
                    <div class="label">Práčovňa</div>
                    <div class="value">{{flatInfo.flat_area_laundry}} m<sup>2</sup></div>
                  </div>
                </div>
                <div class="d-flex justify-content-between border-bottom py-2 pr-3">
                  <div class="label text-uppercase">{{$t('EXTERIÉR')}}</div>
                  <div class="value">{{exterierArea}} m<sup>2</sup></div>
                </div>
                <div class="border-bottom pl-3 py-2 pr-3">
                  <div v-if="flatInfo.flat_area_balcony" class="d-flex justify-content-between pl-5">
                    <div class="label">{{ $t('Balkón') }}</div>
                    <div class="value">{{flatInfo.flat_area_balcony}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_loggia" class="d-flex justify-content-between pl-5">
                    <div class="label">{{$t('Loggia')}}</div>
                    <div class="value">{{flatInfo.flat_area_loggia}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_loggia2" class="d-flex justify-content-between pl-5">
                    <div class="label">{{$t('Loggia')}} 2</div>
                    <div class="value">{{flatInfo.flat_area_loggia2}} m<sup>2</sup></div>
                  </div>
                  <!-- Zelenú plochu posiela Realpad raz ako flat_area_garden, raz ako
                       flat_area_front_garden, v B2 (družstvo) v oboch kľúčoch naraz.
                       Klient chce jediný riadok "Záhrada" – preto fallback, nie súčet. -->
                  <div v-if="flatInfo.flat_area_garden || flatInfo.flat_area_front_garden" class="d-flex justify-content-between pl-5">
                    <div class="label">{{$t('Záhrada')}}</div>
                    <div class="value">{{flatInfo.flat_area_garden || flatInfo.flat_area_front_garden}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_external_storage1" class="d-flex justify-content-between pl-5">
                    <div class="label">{{ $t('Exteriérový sklad') }}</div>
                    <div class="value">{{flatInfo.flat_area_external_storage1}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_external_storage2" class="d-flex justify-content-between pl-5">
                    <div class="label">{{ $t('Exteriérový sklad') }} 2</div>
                    <div class="value">{{flatInfo.flat_area_external_storage2}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_terrace" class="d-flex justify-content-between pl-5">
                    <div class="label">{{$t('Terasa')}}</div>
                    <div class="value">{{flatInfo.flat_area_terrace}} m<sup>2</sup></div>
                  </div>
                  <div v-if="flatInfo.flat_area_terrace2" class="d-flex justify-content-between pl-5">
                    <div class="label">{{$t('Terasa')}} 2</div>
                    <div class="value">{{flatInfo.flat_area_terrace2}} m<sup>2</sup></div>
                  </div>
                </div>
                <div class="d-flex justify-content-between border-bottom py-2 pr-3">
                  <div class="label">{{$t('SPOLU (BYT + EXTERIÉR)')}}</div>
                  <div v-if="flatInfo.building.building_stage == 'boryNoveBloky'" class="value font-weight-bold">{{flatInfo.flat_area_flat_and_exterior}} m<sup>2</sup></div>
                  <div v-else-if="flatInfo.building.building_stage == 'bory5'" class="value font-weight-bold">{{ (Number(flatInfo.flat_area_total) + Number(exterierArea)).toFixed(2) }} m<sup>2</sup></div>
                  <div v-else class="value font-weight-bold">{{flatInfo.flat_area_total}} m<sup>2</sup></div>
                </div>
                <div v-if="flatInfo.building.building_name === 'B2'" class="py-2 pr-3">
                  <div class="d-flex flex-wrap justify-content-between align-items-center py-2 pr-3">
                    <h3 class="label mb-0 pt-0">Členský vklad vo výške 20%:</h3>
                    <div class="value font-weight-bold font-large" style="white-space: nowrap">{{currency(flatInfo.membership_deposit_of_20)}} €</div>
                  </div>
                  <div class="d-flex flex-wrap justify-content-between align-items-center py-2 pr-3">
                    <h3 class="label mb-0 pt-0">Indikatívna výška mesačnej splátky:</h3>
                    <div class="value font-weight-bold font-large" style="white-space: nowrap">{{currency(flatInfo.flat_monthly_payment)}} €</div>
                  </div>
                  <p class="small">Indikatívna výška mesačnej splátky úveru na byt v rámci družstva je vypočítaná pri dobe splatnosti 40 rokov a výške úroku 4,5 % p. a. . Splátka nezahŕňa poplatok za odborné vedenie družstva, poplatok za správu bytového domu, mesačné zálohové platby a ďalšie individuálne náklady ako je napríklad poistenie alebo internet.</p>
                </div>
                <div v-if="flatInfo.flat_status === '0'" class="d-flex justify-content-between align-items-center py-2 pr-3">
                  <div class="label">{{ $t('Cena s DPH:') }}</div>
                  <div v-if="flatInfo.flat_internal_id === 'B.06.A' || (flatInfo.building.building_stage === 'boryNoveBloky' && (String(flatInfo.flat_number_of_rooms).replace(/KK(-A)?$/i, '') === '5' || String(flatInfo.flat_disposition).replace(/KK(-A)?$/i, '') === '5'))" class="value font-weight-bold font-large">Cena na vyžiadanie</div>
                  <div v-else class="value font-weight-bold font-large">{{currency(flatInfo.flat_price_before_discount_vat)}} €</div>
                </div>
                <div v-if="flatInfo.flat_status === '0'" class="d-flex justify-content-center mt-3 border-bottom mb-3 pb-4">
                  <div class="row buttons">
                    <div class="col-12 col-md-6 mb-4 mb-md-0 pl-md-0 pr-md-1">
                      <b-button @click="scrollToContact" class="btn btn-primary rounded-0 d-block">{{ $t('Mám záujem') }}</b-button>
                    </div>
                    <div class="col-12 col-md-6 pr-md-0 pl-md-1">
                      <b-button :href="flatInfo.flat_pdf" target="_blank" squared variant="outline-primary" class="d-block hypo-calc">{{ $t('Stiahnuť PDF') }}</b-button>
                    </div>
                  </div>
                </div>
                <div v-if="flatInfo.building.building_name == 'B2'" class="mt-3"><b-button @click="scrollToContact" class="btn btn-primary w-100 rounded-0 d-block mb-3">Mám záujem</b-button></div>
                <div v-if="flatInfo.building.building_name !== 'B2'" class="pt-3 px-3 d-flex align-items-center flex-column mb-4">
                  <p class="text-center">{{$t('Vypočítajte si výšku svojej mesačnej splátky. Uvedený výpočet splátky hypotekárneho úveru je orientačný.')}}</p>
                  <iframe src="https://hypokalkulacka.m7.sk/hypokalkulacka-na-web-2-black/calculator.php?w=300&h=255&r=0&pbc=21242b&hc=21242b&htc=ffffff&haec=1&bc=21242b&btc=ffffff&bhtc=7bb7d8&baec=0&c=0&l=0&t=1&hodnota_nehnutelnosti=100000" style="width: 300px; height: 255px; padding: 0px; overflow: hidden;" scrolling="no" frameborder="0"></iframe>
                </div>
                <div v-if="flatInfo.building.building_name == 'B2'">
                    <p class="small-font text-white-50">Cena bytu nezahŕňa cenu kobky ani parkovacieho státia. <br>V prípade záujmu je možné členský podiel navýšiť o tieto položky. <br>Cena kobky: od 3&nbsp;300&nbsp;€ s DPH <br>Cena vonkajšieho parkovacieho státia: od 13&nbsp;000 € s DPH <br>Cena vnútorného parkovacieho státia: od 23&nbsp;000 € s DPH <br><br>Byt sa považuje za rezervovaný podpisom Rezervačnej zmluvy a pripísaním rezervačného poplatku.</p>
                </div>
                <div v-else>
                <p class="small-font mb-2 mb-md-0 text-white-50">{{$t('Cena bytu nezahrňuje cenu parkovacieho státia.')}}</p>
                <p class="small-font mb-2 mb-md-0 text-white-50" v-if="flatInfo.building.building_stage === 'bory5' || flatInfo.building.building_stage === 'boryNoveBloky'"></p>
                <p class="small-font mb-2 mb-md-0 text-white-50" v-else>{{ $t('Cena vonkajšieho parkovacieho státia od 11 000 EUR') }}</p>
                  <p class="small-font mb-2 mb-md-0 text-white-50" v-if="flatInfo.building.building_stage === 'bory2b' || flatInfo.building.building_stage === 'bory4'">{{ $t('Cena vnútorného parkovacieho') }}</p>
                  <p class="small-font mb-2 mb-md-0 text-white-50" v-else-if="flatInfo.building.building_stage == 'bory5' || flatInfo.building.building_stage == 'boryNoveBloky'">{{ $t('Cena vnútorného parkovacieho 3') }}</p>
                  <p class="small-font mb-2 mb-md-0 text-white-50">{{ $t('Pre každý byt je povinnosť zakúpiť pivničnú kobku. Developer si vyhradzuje právo zmeny cien dostupných bytov.') }}</p>
                  <p class="small-font mb-2 mb-md-0 text-white-50" >* {{ $t('Byt nie je možné predrezervovať formou kontaktného formulára, byt sa považuje za rezervovaný až v momente podpisu zmluvy.') }}</p>
                  <p class="small-font mb-2 mb-md-0 mt-4 d-block d-md-none text-white-50">{{ $t('Uvedené rozmery a plochy jednotlivých miestností sú predbežné a môžu vykazovať odchýlky.') }}</p>
                  <p class="small-font mb-2 mb-md-0 d-block d-md-none text-white-50">{{ $t('Umiestnenie zariaďovacích predmetov je len ilustračné.') }}</p>
                </div>
                <div v-if="flatInfo.building.building_name == 'B2'" class="pt-3 px-3 d-flex align-items-center flex-column mb-4">
                  <h4 class="text-center mb-3">Zaujíma vás porovnanie mesačnej splátky členského podielu s&nbsp;mesačnou splátkou hypotéky?</h4>
                  <p class="text-center custom-small-font">Rozdiel si môžete jednoducho overiť pomocou hypotekárnej kalkulačky. Pri výpočte mesačnej splátky členského podielu uveďte dobu splatnosti 40 rokov a výšku úrokovej sadzby 4,5 % p. a. </p>
                  <iframe src="https://hypokalkulacka.m7.sk/hypokalkulacka-na-web-2-black/calculator.php?w=300&h=255&r=0&pbc=21242b&hc=21242b&htc=ffffff&haec=1&bc=21242b&btc=ffffff&bhtc=7bb7d8&baec=0&c=0&l=0&t=1&hodnota_nehnutelnosti=100000" style="width: 300px; height: 255px; padding: 0px; overflow: hidden;" scrolling="no" frameborder="0"></iframe>
                </div>
                <p class="small-font mb-2 mb-md-0 mt-4 d-block d-md-none text-white-50">Uvedené rozmery a plochy jednotlivých miestností sú predbežné a môžu vykazovať odchýlky.</p>
                <p class="small-font mb-2 mb-md-0 d-block d-md-none text-white-50">Umiestnenie zariaďovacích predmetov je len ilustračné.</p>
              </div>
              <div class="col-12 col-lg-7 mb-4 mb-md-0">
                <div class="flat-image" :class="{ 'nove-bloky': flatInfo.building.building_stage === 'boryNoveBloky' }">
                  <img :src="flatInfo.flat_plan" alt="">
                  <div class="premium-standard" v-if="(flatInfo.building.building_stage === 'bory2b' || flatInfo.building.building_stage === 'bory4') && flatInfo.flat_number_of_rooms == '3' || flatInfo.flat_number_of_rooms == '4'">
                    <div class="popup-info">
                      <div class="text">
                        {{ $t('Vyšší štandard v cene bytu') }}
                      </div>
                    </div>
                    <div class="icon">
                      <img src="../assets/icons/premium.png">
                    </div>
                  </div>
                  <b-button :href="flatInfo.flat_pdf" target="_blank" squared variant="outline-primary" class="pdf-button"></b-button>
                  <b-button :href="flatInfo.url_link_to_the_vr_apartments_tour" target="_blank" squared variant="outline-primary" class="virtual-button d-block d-md-none"></b-button>
                </div>
                <p class="small-font mb-2 mb-md-0 d-none d-md-block text-white-50">{{ $t('Uvedené rozmery a plochy jednotlivých miestností sú predbežné a môžu vykazovať odchýlky.') }}</p>
                <p class="small-font mb-2 mb-md-0 d-none d-md-block text-white-50">{{ $t('Umiestnenie zariaďovacích predmetov je len ilustračné.') }}</p>
              </div>
            </div>


          </b-tab>
          <b-tab v-if="flatInfo.building.building_stage !== 'boryNoveBloky'" :title="$t('Štandard')" class="tab-standard">
            <div class="d-flex justify-content-center justify-content-md-start">
              <a v-if="flatInfo.building && flatInfo.building.building_stage === 'bory4'" href="../../docs/TS_NaHradzi_3.pdf" class="tech-spec-button" target="_blank"><span><img src="../assets/icons/tech-spec.svg" alt=""></span> {{ $t('Technický štandard bytu') }}</a>
              <a v-if="flatInfo.building && flatInfo.building.building_stage === 'bory2b'" href="../../docs/TS_NovyDvor_4.pdf" class="tech-spec-button" target="_blank"><span><img src="../assets/icons/tech-spec.svg" alt=""></span> {{ $t('Technický štandard bytu') }}</a>
              <a v-if="flatInfo.building && flatInfo.building.building_stage === 'bory3'" href="../../docs/TS_Promenada_2.pdf" class="tech-spec-button" target="_blank"><span><img src="../assets/icons/tech-spec.svg" alt=""></span> {{ $t('Technický štandard bytu') }}</a>
              <a v-if="flatInfo.building && flatInfo.building.building_stage === 'bory5'" href="../../docs/TS_Nadvorie.pdf" class="tech-spec-button" target="_blank"><span><img src="../assets/icons/tech-spec.svg" alt=""></span> {{ $t('Technický štandard bytu') }}</a>
            </div>
            <div id="standards-slider" v-if="flatInfo.building && flatInfo.building.building_stage === 'bory4'">
              <div class="na-hradzi">
                <slick
                    ref="slickStandard"
                    :options="slickOptions"
                    class="slider-for"
                >
                  <div class="slide slide-1">
                    <img src="/standards/na-hradzi/slide-1.jpg">
                    <div class="standards-info">
                      <div class="button-toggle info-1" @click="toggleBox('info-1')">
                        <div class="box box-1 p-3" data-box="info-1">
                          <h4>{{ $t('VYKUROVANIE A PRÍPRAVA TEPLEJ ÚŽITKOVEJ VODY') }}</h4>
                          <p>{{ $t('Na ohrev teplej úžitkovej vody a vykurovanie slúžia v bytových domoch centrálne kotolne, ktoré sú umiestnené v podzemnom podlaží obytných blokov. Vykurovanie izieb bytov je zabezpečené doskovými vykurovacími telesami s termostatickými hlavicami, vykurovanie kúpeľní je zabezpečené rebríkovým radiátorom.') }}</p>
                        </div>
                      </div>
                      <div class="button-toggle info-2" @click="toggleBox('info-2')">
                        <div class="box box-2 p-3" data-box="info-2">
                          <h4>{{ $t('PODLAHY') }}</h4>
                          <p>{{ $t('V predsieni, chodbe, obývacej izbe, izbách, kuchyni, vo vnútornom sklade alt. v šatníku alebo komore laminátová podlaha značky Egger.') }}</p>
                        </div>
                      </div>
                      <div class="button-toggle info-3" @click="toggleBox('info-3')">
                        <div class="box box-3 p-3" data-box="info-3">
                          <h4>{{$t('DELIACE MEDZIBYTOVÉ STENY')}}</h4>
                          <p class="mb-3">{{ $t('Železobetónové steny hrúbky 220 alebo 250 mm.') }}</p>
                          <h4>{{ $t('DELIACE INTERIÉROVÉ PRIEČKY') }}</h4>
                          <p v-html="$t('Sú z&nbsp;keramických tvárnic hrúbky 80, 115 alebo 140 mm.')"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="slide slide-2">
                    <img src="/standards/na-hradzi/slide-2.jpg">
                    <div class="standards-info">
                      <div class="button-toggle info-2-1" @click="toggleBox('info-2-1')">
                        <div class="box box-1 p-3" data-box="info-2-1">
                          <h4>{{$t('OKNÁ')}}</h4>
                          <p>{{ $t('Plastové okná s izolačným trojsklom. Farba okenných rámov a parapetov z vnútornej strany biela, z vonkajšej strany čiernosivá.') }}</p>
                        </div>
                      </div>
                      <div class="button-toggle info-2-2" @click="toggleBox('info-2-2')">
                        <div class="box box-2 p-3" data-box="info-2-2">
                          <h4>EXTERIÉR</h4>
                          <p v-html="$t('Na balkónoch, loggiách a terasách sú použité gresové dlažby do exteriéru, ktoré sú uložené na rektifikačných terčoch. Terasy predzáhradok majú podlahy založené v&nbsp;štrkových lôžkach.')"></p>
                        </div>
                      </div>
                      <div class="button-toggle info-2-3" @click="toggleBox('info-2-3')">
                        <div class="box box-3 p-3" data-box="info-2-3">
                          <h4>{{ $t('TIENENIE') }}</h4>
                          <p>{{ $t('Kastlík s vonkajšími elektrickými žalúziami.') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="slide slide-3">
                    <img src="/standards/na-hradzi/slide-3.jpg">
                    <div class="standards-info">
                      <div class="button-toggle info-3-1" @click="toggleBox('info-3-1')">
                        <div class="box box-1 p-3" data-box="info-3-1">
                          <h4>{{ $t('VSTUPNÉ DVERE DO BYTU') }}</h4>
                          <p v-html="$t('Vstupné bezpečnostné dvere v bezpečnostnej triede 3 s kovaním guľa-kľučka a s priezorníkom. Farba vstupných dverí z&nbsp;vonkajšej strany je&nbsp;šedobéžová (RAL 1019) a farba z vnútornej strany je biela (RAL 9003).')"></p>
                        </div>
                      </div>
                      <div class="button-toggle info-3-2" @click="toggleBox('info-3-2')">
                        <div class="box box-2 p-3" data-box="info-3-2">
                          <h4>{{ $t('INTERIÉROVÉ DVERE') }}</h4>
                          <p class="mb-2" v-html="$t('1,5 – 2-izb. byty – Polodrážkové dvere značky Lignis, plné dverné krídlo z DTD, CPL úprava,priznané nerezové závesy, klasické kovanie/kovanie s&nbsp;magnetickým zámkom.')"></p>
                          <p v-html="$t('3 – 4-izb. byty – Bezfalcové dvere značky Lignis, plné dverné krídlo z&nbsp;DTD, CPL úprava, skryté závesy, klasické kovanie/kovanie s&nbsp;magnetickým zámkom.')"></p>
                        </div>
                      </div>
                      <div class="button-toggle info-3-3" @click="toggleBox('info-3-3')">
                        <div class="box box-3 p-3" data-box="info-3-3">
                          <h4>{{$t('VZDUCHOTECHNIKA')}}</h4>
                          <p class="mb-2" v-html="$t('Predpríprava vzduchotechnického napojenia kuchynského digestora&nbsp;– odbočka zo stúpacieho vzduchotechnického potrubia.')"></p>
                          <p class="mb-2" v-html="$t('Nútené vetranie kúpeľne a&nbsp;WC ventilátorom ovládaným samostatným vypínačom.')"></p>
                          <p class="mb-2" v-html="$t('Hygienické vetranie bytu&nbsp;– akustické vetracie mriežky zabudované v&nbsp;obvodových stenách, podtlak zabezpečujú ventilátory vo WC a v&nbsp;kúpeľni.')"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="slide slide-4">
                    <img src="/standards/na-hradzi/slide-4.jpg">
                    <div class="standards-info">
                      <div class="button-toggle info-4-1" @click="toggleBox('info-4-1')">
                        <div class="box box-3 p-3" data-box="info-4-1">
                          <h4>{{ $t('VAŇA') }}</h4>
                          <p>{{ $t('Smaltová oceľová vaňa značky Kaldewai vrátane vaňovej batérie a ručnej sprchy Grohe.') }}</p>
                        </div>
                      </div>
                      <div class="button-toggle info-4-2" @click="toggleBox('info-4-2')">
                        <div class="box box-1 p-3" data-box="info-4-2">
                          <h4>{{ $t('PODLAHA A OBKLAD') }}</h4>
                          <p>{{ $t('Gressová dlažba značky Ragno Studio.') }}</p>
                        </div>
                      </div>
                      <div class="button-toggle info-4-3" @click="toggleBox('info-4-3')">
                        <div class="box box-2 p-3" data-box="info-4-3">
                          <h4>{{ $t('UMÝVADIELKO') }}</h4>
                          <p>{{ $t('Umývadlo Duravit Vero / Duravit Durasquare vrátane umývadlovej batérie Grohe.') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="slide slide-5">
                    <img src="/standards/na-hradzi/slide-5.jpg">
                    <div class="standards-info">
                      <div class="button-toggle info-5-1" @click="toggleBox('info-5-1')">
                        <div class="box box-1 p-3" data-box="info-5-1">
                          <h4>{{$t('SPRCHA')}}</h4>
                          <p>{{ $t('Sprchová zástena Huppe s gresovou dlažbou a sprchovým žľabom, vrátane sprchového setu a sprchovej batérie Grohe.') }}</p>
                        </div>
                      </div>
                      <div class="button-toggle info-5-2" @click="toggleBox('info-5-2')">
                        <div class="box box-2 p-3" data-box="info-5-2">
                          <h4>{{ $t('TOALETA') }}</h4>
                          <p class="mb-2">{{ $t('1,5 – 2-izb. byty – Závesná rimless WC misa Duravit, podomietkový splachovací systém, ovládanie tlačítkom.') }}</p>
                          <p class="mb-3">{{ $t('3 – 4-izb. byty – Závesná rimless WC misa Duravit so sedátkom so softclose, podomietkový splachovací systém, ovládanie tlačítkom.') }}</p>
                          <h4>{{ $t('UMÝVADLO') }}</h4>
                          <p>{{ $t('V samostatnom WC malé umývadielko Duravit Vero Air vrátane batérie Grohe.') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </slick>
                <slick
                    ref="slickStandardNav1"
                    :options="slickOptionsNav1"
                    class="slider-nav"
                >
                  <div class="slide slide-1">
                    <img src="/standards/na-hradzi/slide-1.jpg">
                  </div>
                  <div class="slide slide-2">
                    <img src="/standards/na-hradzi/slide-2.jpg">
                  </div>
                  <div class="slide slide-3">
                    <img src="/standards/na-hradzi/slide-3.jpg">
                  </div>
                  <div class="slide slide-4">
                    <img src="/standards/na-hradzi/slide-4.jpg">
                  </div>
                  <div class="slide slide-5">
                    <img src="/standards/na-hradzi/slide-5.jpg">
                  </div>
                </slick>
              </div>
            </div>
            <div id="standards-slider" v-if="flatInfo.building && flatInfo.building.building_stage === 'bory5'">
              <div class="nadvorie">
                <slick
                    ref="slickStandard"
                    :options="slickOptions"
                    class="slider-for"
                >
                  <div class="slide slide-1">
                    <img src="/standards/nadvorie/slide-1.jpg">
                    <div class="standards-info">
                      <div class="button-toggle info-1" @click="toggleBox('info-1')">
                        <div class="box box-1 p-3" data-box="info-1">
                          <h4>{{ $t('VYKUROVANIE A PRÍPRAVA TEPLEJ ÚŽITKOVEJ VODY') }}</h4>
                          <p class="mb-2" v-html="$t('<strong>Zdroj tepla pre prípravu TUV</strong> – centrálna kotolňa v podzemnom podlaží.<br><br><strong>Vykurovanie izieb</strong> – doskové vykurovacie telesá s termostatickými hlavicami.<br><br><strong>Kúpeľňa</strong> – rebríkový radiátor kombinovaný s podlahovým kúrením.<br><br><i>*Terasové byty na 6. NP a 7. NP (C.06.A, H.06.B a F.07.A) majú na vykurovanie izieb zapustené podlahové konvektory pred oknami na terasu.</i>')"></p>
                        </div>
                      </div>
                      <div class="button-toggle info-2" @click="toggleBox('info-2')">
                        <div class="box box-2 p-3" data-box="info-2">
                          <h4>{{ $t('VSTUPNÉ DVERE DO BYTU') }}</h4>
                          <p>{{ $t('Vstupné bezpečnostné a požiarne odolné dvere v bezpečnostnej triede 3, vybavené kovaním guľa-kľučka a priezorníkom. Farba dverí aj zárubne je z vonkajšej aj vnútornej strany biela (RAL 9003).') }}</p>
                        </div>
                      </div>
                      <div class="button-toggle info-3" @click="toggleBox('info-3')">
                        <div class="box box-3 p-3" data-box="info-3">
                          <h4>{{ $t('VZDUCHOTECHNIKA') }}</h4>
                          <p v-html="$t('<strong>Predpríprava vzduchotechnického napojenia na komínový kuchynský digestor</strong> (výkon 250 m³/h).<br><br><strong>Nútené vetranie kúpeľne a WC</strong> zabezpečené ventilátorom, ktorý je ovládaný samostatným vypínačom.<br><br><strong>Hygienické vetranie v 1,5 a 2-izbových bytoch</strong> – stenové akustické vetracie mriežky. Podtlak zabezpečujú ventilátory vo WC a v kúpeľni.<br><br><strong>Hygienické vetranie v 3, 4 a 5-izbových bytoch</strong> – rekuperačné jednotky umiestnené v sadrokartónovom podhľade v hygienických priestoroch (WC, kúpeľňa) alebo v priestoroch chodby, ktoré privádzajú čerstvý vzduch do obytných miestností. Odvod vzduchu je zabezpečený cez hygienické priestory a priestory chodieb.')"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="slide slide-2">
                    <img src="/standards/nadvorie/slide-2.jpg">
                    <div class="standards-info">
                      <div class="button-toggle info-2-1" @click="toggleBox('info-2-1')">
                        <div class="box box-1 p-3" data-box="info-2-1">
                          <h4>{{ $t('CHLADENIE') }}</h4>
                          <p v-html="$t('<strong>Príprava pre osadenie chladiacich splitových jednotiek</strong> – zrealizované rozvody chladenia pre všetky izby s podomietkovými krabičkami v pozícii budúceho umiestnenia interiérovej klimatizačnej jednotky a privedený napájací NN rozvod pre exteriérovú chladiacu jednotku, ktorá môže byť umiestnená na loggii bytu, v exteriérovom skladíku, na streche objektu alebo v nike na 1. NP na úrovni terénu. <br><br>Naviac:<br> <strong>3-izbové byty na 6. NP</strong> – zrealizovaná nástenná klimatizačná jednotka v obývacej miestnosti.<br><br><strong>4 a 5-izbové byty</strong> – zrealizované dve kanálové klimatizačné jednotky (obývacia miestnosť a hlavná spálňa), okrem bytu B.02-05.A, kde je v spálni umiestnená nástenná klimatizačná jednotka.')"></p>
                        </div>
                      </div>
                      <div class="button-toggle info-2-2" @click="toggleBox('info-2-2')">
                        <div class="box box-2 p-3" data-box="info-2-2">
                          <h4>{{ $t('INTERIÉROVÉ DVERE') }}</h4>
                          <p class="mb-3" v-html="$t('Polodrážkové dvere značky Lignis, plné dverné krídlo s CPL úpravou. <br><br>Vo vyššom štandarde – bezfalcové dvere značky Lignis, plné dverné krídlo striekané v RAL.')"></p>
                        </div>
                      </div>
                      <div class="button-toggle info-2-3" @click="toggleBox('info-2-3')">
                        <div class="box box-3 p-3" data-box="info-2-3">
                          <h4>{{ $t('DELIACE MEDZIBYTOVÉ STENY') }}</h4>
                          <p class="mb-3">{{ $t('Vnútorné steny - železobetón hrúbky 220 alebo 250 mm.') }}</p>
                          <h4>{{ $t('DELIACE INTERIÉROVÉ PRIEČKY') }}</h4>
                          <p>{{$t('Vnútorné priečky - keramické tvárnice hrúbky 80, 115 alebo 140 mm.')}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="slide slide-3">
                    <img src="/standards/nadvorie/slide-3.jpg">
                    <div class="standards-info">
                      <div class="button-toggle info-3-1" @click="toggleBox('info-3-1')">
                        <div class="box box-1 p-3" data-box="info-3-1">
                          <h4>{{ $t('TIENENIE') }}</h4>
                          <p v-html="$t('Predpríprava na exteriérové elektrické žalúzie – osadený kastlík, vodiace lišty a elektrorozvody pre napojenie žalúzie z exteriéru.<br><br>Terasy strešných bytov na 7. NP a 6. NP bytových domov majú v štandarde bioklimatické pergoly.')"></p>
                        </div>
                      </div>
                      <div class="button-toggle info-3-2" @click="toggleBox('info-3-2')">
                        <div class="box box-2 p-3" data-box="info-3-2">
                          <h4>{{ $t('OKNÁ') }}</h4>
                          <p v-html="$t('Plastové okná s izolačným trojsklom. <br><br>Prízemné byty s predzáhradkami – okenné konštrukcie zabezpečené technológiou pre zvýšenú bezpečnosť proti vlámaniu alebo vandalizmu.<br><br>Okenné rámy a parapety – farba z vnútornej strany biela, farba z vonkajšej strany sivá laminácia (RAL 7039).')"></p>
                        </div>
                      </div>
                      <div class="button-toggle info-3-3" @click="toggleBox('info-3-3')">
                        <div class="box box-3 p-3" data-box="info-3-3">
                          <h4>{{ $t('PODLAHY INTERIÉR') }}</h4>
                          <p v-html="$t('Predsieň, chodba, obývacia izba, izby, kuchyňa, šatník – laminátová podlaha Egger/Kaindl. <br><br>Vo vyššom štandarde – drevená dýhovaná podlaha PAR-ky.')"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="slide slide-4">
                    <img src="/standards/nadvorie/slide-4.jpg">
                    <div class="standards-info">
                      <div class="button-toggle info-4-1" @click="toggleBox('info-4-1')">
                        <div class="box box-1 p-3" data-box="info-4-1">
                          <h4>{{ $t('PERGOLY') }}</h4>
                          <p>{{ $t('Terasy strešných bytov na 6. NP a 7. NP bytových domov majú v štandarde bioklimatické pergoly.') }}</p>
                        </div>
                      </div>
                      <div class="button-toggle info-4-2" @click="toggleBox('info-4-2')">
                        <div class="box box-2 p-3" data-box="info-4-2">
                          <h4>{{ $t('KVETINÁČE') }}</h4>
                          <p>{{ $t('Vybrané terasové byty budú od striech oddelené železobetónovou atikou, pred ktorou budú umiestnené kvetináče s pletivom pre fyzické a vizuálne oddelenie strechy od terasy.') }}</p>
                        </div>
                      </div>
                      <div class="button-toggle info-4-3" @click="toggleBox('info-4-3')">
                        <div class="box box-3 p-3" data-box="info-4-3">
                          <h4>{{ $t('PODLAHY EXTERIÉR') }}</h4>
                          <p v-html="$t('Loggie, balkóny – gresová dlažba na rektifikačných terčoch. <br><br>Terasy predzáhradiek a strešných bytov – terasová drevená podlaha zo sibírskeho smrekovca. <br><br>Terasy predzáhradiek - založené v štrkových lôžkach.')"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="slide slide-5">
                    <img src="/standards/nadvorie/slide-5.jpg">
                    <div class="standards-info">
                      <div class="button-toggle info-5-1" @click="toggleBox('info-5-1')">
                        <div class="box box-1 p-3" data-box="info-5-1">
                          <h4>{{ $t('Exteriérové sklady') }}</h4>
                          <p>{{ $t('Vybrané byty majú na loggiach umiestnený skladík určený pre exteriérovú klimatizačnú jednotku s dvierkami z perforovaného plechu.') }}</p>
                        </div>
                      </div>
                      <div class="button-toggle info-5-2" @click="toggleBox('info-5-2')">
                        <div class="box box-2 p-3" data-box="info-5-2">
                          <h4>{{ $t('ZÁBRADLIE') }}</h4>
                          <p v-html="$t('Loggie, balkóny a všetky okná – oceľové zábradlia s madlami. <br><br>Predzáhradky - betónový múrik v kombinácii s gabiónovymi košmi vrátane popínavých rastlín.')"></p>
                        </div>
                      </div>
                      <div class="button-toggle info-5-3" @click="toggleBox('info-5-3')">
                        <div class="box box-3 p-3" data-box="info-5-3">
                          <h4>{{ $t('PODLAHY EXTERIÉR') }}</h4>
                          <p>{{ $t('Terasy predzáhradiek a strešných bytov - terasová drevená podlaha zo sibírskeho smrekovca.') }}</p>
                          <p>{{ $t('Terasy predzáhradiek- založené v štrkových lôžkach.') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </slick>
                <slick
                    ref="slickStandardNav1"
                    :options="slickOptionsNav2"
                    class="slider-nav"
                >
                  <div class="slide slide-1">
                    <img src="/standards/nadvorie/slide-1.jpg">
                  </div>
                  <div class="slide slide-2">
                    <img src="/standards/nadvorie/slide-2.jpg">
                  </div>
                  <div class="slide slide-3">
                    <img src="/standards/nadvorie/slide-3.jpg">
                  </div>
                  <div class="slide slide-4">
                    <img src="/standards/nadvorie/slide-4.jpg">
                  </div>
                  <div class="slide slide-5">
                    <img src="/standards/nadvorie/slide-5.jpg">
                  </div>
                </slick>
              </div>
            </div>
            <div id="standards-slider" v-if="flatInfo.building && flatInfo.building.building_stage === 'bory2b'">
              <div class="novy-dvor">
                <slick
                    ref="slickStandard"
                    :options="slickOptions"
                    class="slider-for"
                >
                  <div class="slide slide-1">
                    <img src="/standards/novy-dvor/slide-1.jpg">
                    <div class="standards-info">
                      <div class="button-toggle info-1" @click="toggleBox('info-1')">
                        <div class="box box-1 p-3" data-box="info-1">
                          <h4>{{$t('PODLAHY')}}</h4>
                          <p>{{ $t('Predsieň, chodba, obývacia izba, izby, kuchyňa – laminátová podlaha značky Egger.') }}</p>
                        </div>
                      </div>
                      <div class="button-toggle info-2" @click="toggleBox('info-2')">
                        <div class="box box-2 p-3" data-box="info-2">
                          <h4>{{ $t('VSTUPNÉ DVERE DO BYTU') }}</h4>
                          <p>{{ $t('Bezpečnostné, požiarne odolné, bytové dvere v bezpečnostnej triede 3; bezpečnostné kovanie; farba dverí aj zárubní z vnútornej aj vonkajšej strany bytu vo farbe (béžová).') }}</p>
                        </div>
                      </div>
                      <div class="button-toggle info-3" @click="toggleBox('info-3')">
                        <div class="box box-3 p-3" data-box="info-3">
                          <h4>{{ $t('INTERIÉROVÉ DVERE') }}</h4>
                          <p class="mb-2" v-html="$t('1&nbsp;– 2-izb. byty&nbsp;– Polodrážkové dvere značky Lignis, plné dverné krídlo z&nbsp;DTD, CPL úprava, priznané nerezové závesy, klasické kovanie/kovanie s&nbsp;magnetickým zámkom.')"></p>
                          <p v-html="$t('3&nbsp;– 4-izb. byty&nbsp;– Bezfalcové dvere značky Lignis, plné dverné krídlo z&nbsp;DTD, CPL úprava, skryté závesy, klasické kovanie/kovanie s&nbsp;magnetickým zámkom.')"></p>
                        </div>
                      </div>
                      <div class="button-toggle info-4" @click="toggleBox('info-4')">
                        <div class="box box-4 p-3" data-box="info-4">
                          <h4>{{ $t('VZDUCHOTECHNIKA') }}</h4>
                          <p class="mb-2" v-html="$t('Predpríprava vzduchotechnického napojenia kuchynského digestora&nbsp;– odbočka zo stúpacieho vzduchotechnického potrubia s&nbsp;osadením spätnej klapky v&nbsp;mieste inštalačného jadra.')"></p> 
                          <p class="mb-2" v-html="$t('Nútené vetranie kúpeľne a&nbsp;WC ventilátorom ovládaným samostatným vypínačom.')"></p>
                          <p v-html="$t('Hygienické vetranie bytu - akustické vetracie mriežky zabudované v&nbsp;okenných konštrukciách, podtlak zabezpečujú ventilátory vo WC a v&nbsp;kúpeľni.')"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="slide slide-2">
                    <img src="/standards/novy-dvor/slide-2.jpg">
                    <div class="standards-info">
                      <div class="button-toggle info-2-1" @click="toggleBox('info-2-1')">
                        <div class="box box-1 p-3" data-box="info-2-1">
                          <h4>{{ $t('VYKUROVANIE A PRÍPRAVA TEPLEJ ÚŽITKOVEJ VODY') }}</h4>
                          <p>{{ $t('Zdrojom tepla na prípravu TÚV pre bytové domy je kotolňa umiestnená v podzemnom podlaží každého obytného bloku. Vykurovanie izieb je zabezpečené doskovými vykurovacími telesami s termoregulačnými hlavicami, v kúpeľni rebríkovým radiátorom.') }}</p>
                        </div>
                      </div>
                      <div class="button-toggle info-2-2" @click="toggleBox('info-2-2')">
                        <div class="box box-2 p-3" data-box="info-2-2">
                          <h4>{{ $t('DELIACE MEDZIBYTOVÉ STENY') }}</h4>
                          <p class="mb-3">{{ $t('Železobetónové s hrúbkou 250 mm a 220 mm spĺňajúce požiadavky na zvukovú izoláciu deliacich konštrukcií podľa príslušnej normy STN.') }}</p>
                          <h4>{{ $t('DELIACE INTERIÉROVÉ PRIEČKY') }}</h4>
                          <p>{{ $t('Murované z tehál s hrúbkou 115 mm alebo 140 mm.') }}</p>
                        </div>
                      </div>
                      <div class="button-toggle info-2-3" @click="toggleBox('info-2-3')">
                        <div class="box box-3 p-3" data-box="info-2-3">
                          <h4>{{ $t('OKNÁ') }}</h4>
                          <p>{{ $t('Plastové okná s izolačným trojsklom, farba rámu z vnútornej strany biela, z vonkajšej strany vo farbe (béžová), vonkajšie parapety vo farbe okenného rámu, vnútorný parapet bielej farby.') }}</p>
                        </div>
                      </div>
                      <div class="button-toggle info-2-4" @click="toggleBox('info-2-4')">
                        <div class="box box-4 p-3" data-box="info-2-4">
                          <h4>{{ $t('TIENENIE') }}</h4>
                          <p>{{ $t('Podľa typu bytu vonkajšie žalúzie alebo predpríprava na vonkajšie žalúzie alebo posuvné perforované tieniace panely.') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="slide slide-3">
                    <img src="/standards/novy-dvor/slide-3.jpg">
                    <div class="standards-info">
                      <div class="button-toggle info-3-1" @click="toggleBox('info-3-1')">
                        <div class="box box-1 p-3" data-box="info-3-1">
                          <h4>{{ $t('PODLAHA A OBKLAD') }}</h4>
                          <p>{{ $t('Gresová dlažba a obklad Ragno Rewind.') }}</p>
                        </div>
                      </div>
                      <div class="button-toggle info-3-2" @click="toggleBox('info-3-2')">
                        <div class="box box-2 p-3" data-box="info-3-2">
                          <h4>{{ $t('UMÝVADLO') }}</h4>
                          <p>{{ $t('Umývadlo Duravit Vero vrátane umývadlovej batérie Grohe.') }}</p>
                        </div>
                      </div>
                      <div class="button-toggle info-3-3" @click="toggleBox('info-3-3')">
                        <div class="box box-3 p-3" data-box="info-3-3">
                          <h4>{{ $t('VAŇA') }}</h4>
                          <p>{{ $t('Smaltovaná vaňa Kaldewai vrátane vaňovej batérie a ručnej sprchy Grohe.') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="slide slide-4">
                    <img src="/standards/novy-dvor/slide-4.jpg">
                    <div class="standards-info">
                      <div class="button-toggle info-4-1" @click="toggleBox('info-4-1')">
                        <div class="box box-1 p-3" data-box="info-4-1">
                          <h4>{{ $t('SPRCHOVY KÚT') }}</h4>
                          <p>{{ $t('Sprchová zástena Roth vrátane sprchového setu a sprchovej batérie Grohe.') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="slide slide-5">
                    <img src="/standards/novy-dvor/slide-5.jpg">
                    <div class="standards-info">
                      <div class="button-toggle info-5-1" @click="toggleBox('info-5-1')">
                        <div class="box box-1 p-3" data-box="info-5-1">
                          <h4>{{ $t('TOALETA') }}</h4>
                          <p>{{ $t('Závesná rimless WC misa Duravit so sedátkom (s/bez softclose), podomietkový splachovací systém vrátane tlačidla.') }}</p>
                        </div>
                      </div>
                      <div class="button-toggle info-5-2" @click="toggleBox('info-5-2')">
                        <div class="box box-2 p-3" data-box="info-5-2">
                          <h4>{{ $t('UMÝVADIELKO') }}</h4>
                          <p>{{ $t('Malé umývadielko Duravit Vero Air vrátane batérie Grohe.') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </slick>
                <slick
                    ref="slickStandardNav1"
                    :options="slickOptionsNav1"
                    class="slider-nav"
                >
                  <div class="slide slide-1">
                    <img src="/standards/novy-dvor/slide-1.jpg">
                  </div>
                  <div class="slide slide-2">
                    <img src="/standards/novy-dvor/slide-2.jpg">
                  </div>
                  <div class="slide slide-3">
                    <img src="/standards/novy-dvor/slide-3.jpg">
                  </div>
                  <div class="slide slide-4">
                    <img src="/standards/novy-dvor/slide-4.jpg">
                  </div>
                  <div class="slide slide-5">
                    <img src="/standards/novy-dvor/slide-5.jpg">
                  </div>
                </slick>
              </div>
            </div>
            <div class="accordion" role="tablist" v-if="flatInfo.building && flatInfo.building.building_stage !== 'bory4' && flatInfo.building.building_stage !== 'bory2b' && flatInfo.building.building_stage !== 'bory5'  && flatInfo.building.building_stage !== 'bory5'">
              <b-card no-body class="mb-0" v-for="(standard, index) in flatStandards" :key="index">
                <b-card-header header-tag="header" class="p-0 d-flex justify-content-between" role="tab">
                  <b-button block v-b-toggle="'accordion-'+index">{{ $t(standard.title) }}<span></span><span></span></b-button>
                </b-card-header>
                <b-collapse :id="'accordion-' + index" accordion="my-accordion" role="tabpanel">
                  <b-card-body v-html="$t(standard.text)">
                    
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
            <p class="small-font m-0 mt-4 text-white-50" v-if="flatInfo.building && flatInfo.building.building_stage !== 'bory4' && flatInfo.building.building_stage !== 'bory2b'  && flatInfo.building.building_stage !== 'bory5'">{{ $t('Všetky konštrukcie a povrchy budú zrealizované v zmysle platných noriem a predpisov.') }}</p>
            <p class="small-font m-0 text-white-50" v-if="flatInfo.building && flatInfo.building.building_stage !== 'bory4' && flatInfo.building.building_stage !== 'bory2b'  && flatInfo.building.building_stage !== 'bory5'">{{ $t('Budúci predávajúci si vyhradzuje právo zmeny jednotlivých položiek a ich náhradu položkami porovnateľnej kvality.') }}</p>
          </b-tab>
          <b-tab :title="$t('Financovanie')">
            <div v-if="flatInfo.building.building_name == 'B2'" class="row">
              <div class="col-md-8 col-12 left-line mb-5">
                <div class="item py-3">
                  <div class="num">1</div>
                  <div class="item-header">
                    <p class="mb-0">Vyberiete si byt, o ktorý máte záujem.</p>
                  </div>
                </div>

                <div class="item py-3">
                  <div class="num">2</div>
                  <div class="item-header">
                    <p class="mb-0">Podpíšete rezervačnú zmluvu a uhradíte rezervačný poplatok vo výške 5 000 €.</p>
                  </div>
                </div>
                <div class="item py-3">
                  <div class="num">3</div>
                  <div class="item-header">
                    <p class="mb-0">Spolu s podaním prihlášky do družstva uhrádzate 20 % z celkovej ceny bytu.
                    </p>
                  </div>
                </div>
                <div class="item py-3">
                  <div class="num">4</div>
                  <div class="item-header">
                    <p class="mb-0">Po schválení vašej prihlášky do družstva uhradíte poplatky do jednotlivých fondov. Následne uzavriete nájomnú zmluvu na vybraný byt a môžete začať bývať.
                    </p>
                  </div>
                </div>
                <div class="item py-3">
                  <div class="num">5</div>
                  <div class="item-header">
                    <p class="mb-0">Po splatení celkovej ceny bytu môžete požiadať družstvo o prevod bytu do osobného vlastníctva.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="row finance mb-5">
              <div class="col-12 col-md-7" v-if="flatInfo.building && flatInfo.building.building_stage == 'bory3' || flatInfo.building.building_stage == 'bory2b' || flatInfo.building.building_stage == 'bory4'">
                <h4 class="mb-4">{{ $t('Splátkový kalendár') }}</h4>
                <div class="d-flex box-wrapper">
                  <div class="box mr-0 mr-md-3">
                    <p class="mb-1">{{ $t('Prvá splátka') }}</p>
                    <h4 style="font-size: 56px;">5 000 €</h4>
                  </div>
                  <div class="box">
                    <h4 class="mb-1" style="font-size: 30px;">{{ $t('Zvyšok kúpnej ceny') }}</h4>
                  </div>
                </div>
              </div>
              <div class="col-12 col-xl-7" v-else>
                <h4 class="mb-4">{{ $t('Splátkový kalendár') }} 10/90</h4>
                <div class="d-flex box-wrapper">
                  <div class="d-flex box-wrapper">
                    <div class="box mr-0 mr-md-3">
                      <h4 class="mb-1">10 <span>%</span></h4>
                      <p v-if="flatInfo.building.building_stage == 'bory5' || flatInfo.building.building_stage == 'boryNoveBloky'" v-html="$t('po podpise Zmluvy o budúcej zmluve s platbou v dvoch splátkach.')"></p>
                      <p v-else v-html="$t('po podpise <strong>Zmluvy o&nbsp;budúcej zmluve</strong>')"></p>
                    </div>
                  </div>
                  <div class="d-flex box-wrapper price" v-if="flatInfo.building.building_stage == 'bory5' || flatInfo.building.building_stage == 'boryNoveBloky'">
                    <div class="box mr-0 mr-md-3">
                      <p>{{ $t('Na prvú splátku vám postačí len') }}</p>
                      <h4>5 000 <span>€</span></h4>
                      <p>{{ $t('Do 30 kalendárnych dní doplatíte zvyšnú sumu do výšky 10 % kúpnej ceny.') }}</p>
                    </div>
                  </div>
                  <div class="d-flex box-wrapper">
                    <div class="box">
                      <h4 class="mb-1">90 <span>%</span></h4>
                      <p>{{ $t('po kolaudácii') }}</p>
                    </div>
                  </div>
                </div>
                
              </div>
              <div class="col-12 col-xl-5">
                <h4 class="md-3 mb-md-5">{{ $t('Možnosti financovania') }}</h4>
                <p class="mb-3" v-html="$t('Najvýhodnejšie možnosti financovania bytu v projekte Bory Bývanie <br>Vám poskytne náš hypotekárny poradca')"></p>
                <div class="contact">
                  <p class="mb-2 name">Ing. Dušan Baňacký</p>
                  <p class="mb-2"><a href="tel:+421940505000 ">+421 940 505 000</a></p>
                  <p><a href="mailto:banacky@valen.sk">banacky@valen.sk</a></p>
                </div>
              </div>
            </div>
            <div class="sample p-md-3" v-if="flatInfo.building.building_name !== 'B2'">
              <div class="d-flex flex-wrap">
                <div class="col-md-6 pt-md-4 pl-md-5 text-left" v-if="flatInfo.building.building_stage == 'boryNoveBloky'">
                  <div class="category">{{ $t('Zaujímavosti') }}</div>
                  <h3 v-html="$t('Ako financovať vaše bývanie v etape Bory Nové Bloky?')"></h3>
                  <p v-html="$t('Cesta k vášmu vysnívanému bývaniu nemusí byť <br>zložitá.Priblížime vám možnosti aj proces financovania<br> vašej novej nehnuteľnosti v našich projektoch.')"></p>
                  <a href="/novinky/ako-financovat-vase-byvanie-v-etape-bory-nadvorie" class="btn btn-primary rounded-0 py-3 font-weight-bold">{{ $t('Prečítajte si článok') }}</a>
                </div>
                <div class="col-md-6 pt-md-4 pl-md-5 text-left" v-else-if="flatInfo.building.building_stage == 'bory5'">
                  <div class="category">{{ $t('Zaujímavosti') }}</div>
                  <h3 v-html="$t('Ako financovať vaše<br> bývanie na Boroch?')"></h3>
                  <p v-html="$t('Cesta k vášmu vysnívanému bývaniu nemusí byť <br>zložitá.Priblížime vám možnosti aj proces financovania<br> vašej novej nehnuteľnosti v našich projektoch.')"></p>
                  <a href="/novinky/ako-financovat-vase-byvanie-v-etape-bory-nadvorie" class="btn btn-primary rounded-0 py-3 font-weight-bold">{{ $t('Prečítajte si článok') }}</a>
                </div>
                <div class="col-md-6 pt-md-4 pl-md-5 text-left" v-else>
                  <div class="category">{{ $t('Zaujímavosti') }}</div>
                  <h3 v-html="$t('Ako financovať vaše<br> bývanie na Boroch?')"></h3>
                  <p v-html="$t('Cesta k vášmu vysnívanému bývaniu nemusí byť <br>zložitá.Priblížime vám možnosti aj proces financovania<br> vašej novej nehnuteľnosti v našich projektoch.')"></p>
                  <a href="/novinky/ako-financovat-vase-byvanie-na-boroch" class="btn btn-primary rounded-0 py-3 font-weight-bold">{{ $t('Prečítajte si článok') }}</a>
                </div>
                <div class="col-md-6 mt-3 mt-md-0 img-bg ml-0 pr-0" v-if="flatInfo.building.building_stage == 'bory5'">
                  <img src="../assets/images/nadvorie_teas.jpg" alt="">
                </div>
                <div class="col-md-6 mt-3 mt-md-0 img-bg ml-0 pr-0" v-else>
                  <img src="/gallery/bory2/interier/Bory-Byvanie-2-interier-6.jpg" alt="">
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab v-if="flatInfo.building.building_name !== 'B2' && flatInfo.building.building_stage !== 'boryNoveBloky'" @click.prevent="goToPage($event)">
            <template #title>
              фінансування <img class="ml-2" src="../assets/images/ukraine.png" height="18" alt="">
            </template>
          </b-tab>
          <b-tab v-if="flatInfo.building.building_name === 'B2'" @click.prevent="goToPage($event)">
            <template #title>
              Informácie o Bory Družstevnom Bývaní
            </template>
          </b-tab>
          <b-tab v-if="flatInfo.building.building_name !== 'B2'" :title="$t('Postup pri kúpe')">
            <div class="col-md-8 col-12 left-line mb-5">
              <div class="item py-3">
                <div class="num">1</div>
                <div class="item-header">
                  <p class="mb-0">{{ $t('Dohodnete si stretnutie s predajcom') }}</p>
                </div>
              </div>

              <div class="item py-3">
                <div class="num">2</div>
                <div class="item-header">
                  <p class="mb-0" v-if="flatInfo.building.building_stage == 'bory5' || flatInfo.building.building_stage == 'boryNoveBloky'">{{ $t('Podpíšete zmluvu o budúcej zmluve a uhrádzate prvú časť kúpnej ceny vo výške 10 %, v dvoch splátkach, pričom prvá splátka predstavuje sumu vo výške 5 000 €.') }}</p>
                  <p class="mb-0" v-else>{{ $t('Podpíšete kúpnu zmluvu a kúpnu cenu uhradíte v dvoch splátkach.') }}
                  </p>
                </div>
              </div>
              <div class="item py-3">
                <div class="num">3</div>
                <div class="item-header">
                  <p class="mb-0" v-if="flatInfo.building.building_stage == 'boryNoveBloky'">{{ $t('Do 5 pracovných dní od podpisu kúpnej zmluvy uhrádzate prvú splátku vo výške 5 000 €. Do 30 kalendárnych dní doplatíte zvyšnú sumu do výšky 10 % kúpnej ceny.') }}</p>
                  <p class="mb-0" v-else>{{ $t('Do 5 pracovných dní od podpisu kúpnej zmluvy uhrádzate prvú splátku vo výške 5 000 €.') }}
                  </p>
                </div>
              </div>
              <div class="item py-3">
                <div class="num">4</div>
                <div class="item-header">
                  <p class="mb-0" v-if="flatInfo.building.building_stage == 'bory5' || flatInfo.building.building_stage == 'boryNoveBloky'">{{ $t('Po kolaudácii zaplatíte zvyšnú časť kupnej ceny vo výške 90%.') }}
                  </p>
                  <p class="mb-0" v-else>{{ $t('Uhradíte zvyšok kúpnej ceny') }}
                  </p>
                </div>
              </div>
              <div class="item py-3">
                <div class="num">5</div>
                <div class="item-header">
                  <p class="mb-0">{{ $t('Po vyplatení 100 % kúpnej ceny vám odovzdávame vaše nové bývanie a my za vás podáme aj kúpnu zmluvu s návrhom na vklad vlastníckeho práva na kataster') }}</p>
                </div>
              </div>
            </div>
            <b-button @click="scrollToFooter" class="btn btn-primary rounded-0 d-block">{{ $t('Dohodnúť si stretnutie s predajcom') }}</b-button>
          </b-tab>
          <b-tab v-if="flatInfo.building.building_name !== 'B2'" :title="$t('Harmonogram výstavby')">
            <div class="accordion" role="tablist">
              <ScheduleTimeline :phases="constructionPhases" bare>
                <h3 class="mb-3" slot="before" v-if="flatInfo.building.building_stage === 'bory2' || flatInfo.building.building_stage === 'bory2b'">{{ $t('2. Fáza') }}</h3>
              </ScheduleTimeline>
            </div>
          </b-tab>
          <template #tabs-end>
            <b-nav-item class="virtual" :href="flatInfo.url_link_to_the_vr_apartments_tour" target="_blank" role="presentation" @click="() => {}" v-if="flatInfo.building && flatInfo.url_link_to_the_vr_apartments_tour">{{ $t('Virtuálna prehliadka') }}</b-nav-item>
          </template>
        </b-tabs>
      </div>

    </div>
    <ContactForm :internalId="flatInfo.flat_internal_id" :building="flatInfo.building.building_name" :stage="flatInfo.building.building_stage"></ContactForm>
    <div class="d-flex spinner" v-if="isLoading">
      <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import standards from "@/data/standards.json"
import ContactForm from "@/components/shared/ContactForm";
import Slick from "vue-slick";
import ScheduleTimeline from "@/components/home/ScheduleTimeline";
import FlatHeader from "@/components/flats/FlatHeader";
import { mapGetters, mapActions } from 'vuex'
import collect from 'collect.js'
import { getCookie, setCookie } from '@/utils/cookies'

const CONSTRUCTION_SCHEDULES = {
  boryNoveBloky: [
    { icon: 'zahajenie-vystavby', title: 'Začiatok<br> výstavby', date: '4. kvartál 2026', status: 'fill-min' },
    { icon: 'hruba-stavba', title: 'Žiadosť<br> o kolaudáciu', date: '3. kvartál 2029' },
    { icon: 'kolaudacia', title: 'Kolaudačný<br> proces', date: '4. kvartál 2029' },
    { icon: 'odovzdanie-bytov', title: 'Odovzdávanie<br> bytov', date: '1. - 2. kvartál 2030' },
    { icon: 'kluce-byvanie', title: 'Vaše<br> bývanie' }
  ],
  bory5: [
    { icon: 'zahajenie-vystavby', title: 'Začiatok<br> výstavby', date: '3. kvartál 2025', status: 'fill-min' },
    { icon: 'hruba-stavba', title: 'Žiadosť<br> o kolaudáciu', date: '3. kvartál 2027' },
    { icon: 'kolaudacia', title: 'Kolaudačný<br> proces', date: '4. kvartál 2027' },
    { icon: 'odovzdanie-bytov', title: 'Odovzdávanie<br> bytov', date: '1. - 2. kvartál 2028' },
    { icon: 'kluce-byvanie', title: 'Vaše<br> bývanie' }
  ],
  bory4: [
    { icon: 'zahajenie-vystavby', title: 'Začiatok<br> výstavby', date: '3. kvartál 2021', status: 'fill-min' },
    { icon: 'hruba-stavba', title: 'Žiadosť<br> o kolaudáciu', date: '3. kvartál 2023' },
    { icon: 'kolaudacia', title: 'Kolaudačný<br> proces', date: '4. kvartál 2023' },
    { icon: 'odovzdanie-bytov', title: 'Odovzdávanie<br> bytov', date: '1. - 2. kvartál 2024' },
    { icon: 'kluce-byvanie', title: 'Vaše<br> bývanie' }
  ],
  bory3: [
    { icon: 'zahajenie-vystavby', title: 'Začiatok<br> výstavby', date: '3. kvartál 2020', status: 'fill' },
    { icon: 'hruba-stavba', title: 'Žiadosť<br> o kolaudáciu', date: '3. kvartál 2022', status: 'fill-min' },
    { icon: 'kolaudacia', title: 'Kolaudačný<br> proces', date: '3. - 4. kvartál 2022' },
    { icon: 'odovzdanie-bytov', title: 'Odovzdávanie<br> bytov', date: '1. - 3. kvartál 2023' },
    { icon: 'kluce-byvanie', title: 'Vaše<br> bývanie' }
  ],
  bory2: [
    { icon: 'zahajenie-vystavby', title: 'Začiatok<br> výstavby', date: '1. kvartál 2021', status: 'fill-min', roundLabel: '2. Fáza' },
    { icon: 'hruba-stavba', title: 'Koniec<br> výstavby', date: '2. kvartál 2023', roundLabel: '2. Fáza' },
    { icon: 'kolaudacia', title: 'Kolaudačný<br> proces', date: '3. kvartál 2023', roundLabel: '2. Fáza' },
    { icon: 'odovzdanie-bytov', title: 'Odovzdávanie<br> bytov', date: '4. kvartál 2023', roundLabel: '2. Fáza' }
  ]
}
CONSTRUCTION_SCHEDULES.bory2b = CONSTRUCTION_SCHEDULES.bory2

export default {
  name: "FlatDetail",
  components: {ContactForm, Slick, ScheduleTimeline, FlatHeader},
  computed: {
    ...mapGetters('flats', ['flats']),
    constructionPhases() {
      const stage = this.flatInfo.building ? this.flatInfo.building.building_stage : null
      return CONSTRUCTION_SCHEDULES[stage] || []
    }
  },
  data() {
    return {
      selectedItems: [],
      isLoading: false,
      flatId: this.$route.params.id,
      flatInfo: [],
      stage: this.$route.params.stage,
      flatStandards: null,
      filter: this.$route.params.filter,
      floor: this.$route.params.floor,
      building: this.$route.params.building,
      exterierArea: null,
      prevRoute: null,
      tabIndex: 0,
      compare: [],
      compareArr: [],
      isInCompare: false,
      loaded: false,
      slickOptions: {
        infinite: false,
        adaptiveHeight: true,
        dots: false,
        arrows: false,
        asNavFor: '.slider-nav'
        // Any other options that can be got from plugin documentation
        // responsive: [
        //   {
        //     breakpoint: 1024,
        //     settings: {
        //       slidesToShow: 2
        //     }
        //   }
        //   // You can unslick at a given breakpoint now by adding:
        //   // settings: "unslick"
        //   // instead of a settings object
        // ]
      },
      slickOptionsNav1: {
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        asNavFor: '.slider-for',
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              dots: true
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      },
      slickOptionsNav2: {
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        asNavFor: '.slider-for',
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              dots: true
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      }
    }
  },
  async mounted() {
    window.scrollTo(0, 0)
    this.isLoading = true
    await this.loadFlats()
    await axios
        .get(`${process.env.VUE_APP_API_URL}/api/v1/apartment-houses/` + this.stage + '/' + this.flatId)
        .then((response) => {
          this.flatInfo = response.data.data
          let stndrd = null
          if (response.data.data.building.building_stage === 'bory3')
            stndrd = standards.main.bory3
          else if (response.data.data.building.building_stage === 'bory4')
            stndrd = standards.main.bory4
          else
            stndrd = standards.main.bory2
          this.flatStandards = stndrd
          this.isLoading = false
          let exterier = []
          if (this.stage == 'bory3b') {
            exterier = [
              response.data.data.flat_area_balcony,
              response.data.data.flat_area_loggia,
              response.data.data.flat_area_loggia2,
              response.data.data.flat_area_garden || response.data.data.flat_area_front_garden,
              response.data.data.flat_area_external_storage1,
              response.data.data.flat_area_external_storage2,
              response.data.data.flat_area_terrace,
              response.data.data.flat_area_terrace2,
            ]
          } else if (this.stage == 'bory5') {
              exterier = [
                response.data.data.flat_area_balcony,
                response.data.data.flat_area_loggia,
                response.data.data.flat_area_loggia2,
                response.data.data.flat_area_garden || response.data.data.flat_area_front_garden,
                response.data.data.flat_area_terrace,
                response.data.data.flat_area_terrace2,
              ]
          } else {
            exterier = [
              response.data.data.flat_area_balcony,
              response.data.data.flat_area_loggia,
              response.data.data.flat_area_loggia2,
              response.data.data.flat_area_garden || response.data.data.flat_area_front_garden,
              response.data.data.flat_area_external_storage1,
              response.data.data.flat_area_external_storage2,
              response.data.data.flat_area_terrace,
              response.data.data.flat_area_terrace2,
            ]
          }
          
          const toNumber = n => isNaN(n) ? 0 : Number(n)
          this.exterierArea = exterier.reduce((a, b) => toNumber(a) + toNumber(b)).toFixed(2)
          document.title = this.flatInfo.flat_penta_internal_id ? 'Byt ' + this.flatInfo.flat_penta_internal_id + ' - Bory bývanie' : 'Detail bytu'
          this.loaded = true
        })

      if (getCookie('compareFlats')) {
        const selItems = this.selectedItems
        const compareFlats = JSON.parse(getCookie('compareFlats'))
        this.isInCompare = compareFlats.includes(this.flatInfo.flat_penta_internal_id)
        this.compareArr = compareFlats.length
        this.compare = collect(this.flats).whereIn('flat_penta_internal_id', compareFlats).all()
        this.compare.forEach(element => {
          selItems.push(element.flat_penta_internal_id)
        });
      }
  },
  methods: {
    ...mapActions('flats', ['loadFlats']),
    toCompareTable(e) {
      if (e.target.classList.contains('delete-item')) {
        return
      }
      this.$router.push({
        name: 'Flats',
        hash: '#compare-table',
        params: {floor: this.floor, building: this.building},
        query: { filter: JSON.stringify(this.filter) }
      })
    },
    addToCompare(data) {
      if (this.compare.length >= 4) {
        this.$bvToast.toast(`Do porovnania môžete pridať maximálne 4 byty`, {
          title: `Porovnanie bytov`,
          toaster: 'b-toaster-bottom-right',
          solid: true,
          variant: 'info',
          appendToast: true
        })
        return
      }
      const aa = collect(data).only('flat_penta_internal_id','flat_price', 'flat_number_of_rooms').all()
      this.compare.push(aa)
      this.selectedItems.push(aa)
      let compareFlats = JSON.parse(getCookie('compareFlats'))
      if (!compareFlats) {
        compareFlats = []
      }
      compareFlats.push(data.flat_penta_internal_id)
      setCookie('compareFlats', JSON.stringify(compareFlats), 1)
      this.isInCompare = true
    },
    removeFromCompare(data) {
      const aaa = this.compare.findIndex(p => p.flat_penta_internal_id == data.flat_penta_internal_id);
      this.compare.splice(aaa, 1);
      const compareFlats = JSON.parse(getCookie('compareFlats'))
      const flatId = compareFlats.findIndex(p => p == data.flat_penta_internal_id);
      compareFlats.splice(flatId, 1)
      this.selectedItems.splice(flatId, 1)
      setCookie('compareFlats', JSON.stringify(compareFlats), 1)
      this.isInCompare = false
      this.compareArr = this.compare - 1
    },
    goToPage(e) {
      e.preventDefault()
      e.stopPropagation()
      if (this.stage == 'bory5') {
        const routeData = this.$router.resolve({name: 'UaFinancovanieNadvorie'});
        window.open(routeData.href, '_blank');
      } else if (this.flatInfo.building.building_name === 'B2') {
        const routeData = this.$router.resolve({name: 'DruzstevneByvanie'});
        window.open(routeData.href, '_blank');
      } else {
        const routeData = this.$router.resolve({name: 'UaFinancovanie'});
        window.open(routeData.href, '_blank');
      }
    },
    tabChange(e) {
      if (e == 3 && this.stage !== 'boryNoveBloky') {
        this.tabIndex = 2
      }
      if (this.stage === 'bory2b' || this.stage === 'bory4' || this.stage === 'bory5') {
        this.$refs.slickStandard.reSlick();
        this.$refs.slickStandardNav1.reSlick();
        // this.$refs.slickStandardNav2.reSlick();
      }

      if (e == 4 && this.flatInfo.building.building_name == 'B2') {
        this.$nextTick(() => {
          this.tabIndex = 0
        })
      }
      
    },

    scrollToContact() {
      const contactForm = document.getElementById('contact-form')
      contactForm.scrollIntoView({behavior: "smooth", block: 'center'})

    },
    scrollToFooter() {
      const contactForm = document.getElementById('contact-footer')
      contactForm.scrollIntoView({behavior: "smooth", block: 'start'})

    },
    currency: price => {
      let value = parseFloat(price)
      value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      return `${value}`
    },
    backToFlats() {
      this.$router.push({
        name: this.prevRoute.name ? this.prevRoute.name : 'Flats',
        hash: '#tabulka',
        params: {floor: this.floor, building: this.building},
        query: { filter: JSON.stringify(this.filter) }
      })
    },
    toggleBox(val) {
      document.querySelector('.' + val).classList.toggle('clicked')
      document.querySelector('[data-box="' + val + '"]').classList.toggle('show')
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  }
}
</script>

<style lang="sass" scoped>
$md: 768px

.custom-small-font
  font-size: 15px
  font-weight: 300

.premium-standard
  position: absolute
  left: 80px
  bottom: 22px

  @media (max-width: $md)
    left: 5px
    bottom: auto
    top: 5px

  &:hover
    .popup-info
      width: 240px
      transition: all 0.3s ease

      .text
        opacity: 1
        transition: all 0.6s 0.2s ease
  .icon
    width: 46px
    height: 46px
    display: flex
    align-items: center
    justify-content: center

    img
      max-width: 100%

  .popup-info
    content: ""
    position: absolute
    z-index: 9
    top: 50%
    left: 50px
    width: 0px
    height: 50px
    transform: translateY(-50%)
    background: var(--blue)
    transition: all 0.3s 0.3s ease
    display: flex
    align-items: center

    .text
      font-size: 16px
      font-weight: 600
      color: var(--dark)
      text-align: center
      line-height: 1
      opacity: 0
      width: 240px
      transition: all 0.6s ease
      pointer-events: none

.offer-price
  font-size: 18px
  @media (max-width: $md)
    max-width: 50%

.offer-info
  margin-bottom: 40px
  p
    font-size: 14px
    color: var(--blue)

    a
      text-decoration: underline

.test
  min-height: 1500px

.tech-spec-button
  color: #fff
  font-size: 16px
  margin-bottom: 30px
  display: inline-block
  margin-left: 10px
  display: flex
  align-items: center
  box-shadow: inset 48px 0 0 0 var(--blue)
  -webkit-transition: ease-out 0.4s
  -moz-transition: ease-out 0.4s
  transition: ease-out 0.4s
  text-decoration: none
  padding-right: 15px

  @media (max-width: $md)
    font-size: 14px
    background: var(--blue)
    margin-left: 0
    box-shadow: none

  &:hover
    box-shadow: inset 330px 0 0 0 var(--blue)

  span
    display: flex
    align-items: center
    justify-content: center
    margin-right: 10px
    width: 48px
    height: 48px

    @media (max-width: $md)
      margin-right: 5px

.compare-button
  background: #DCF2FF
  box-shadow: 0px 20px 60px rgba(0, 0, 0, 0.2)
  position: fixed
  right: 60px
  bottom: 80px
  z-index: 1099
  cursor: pointer
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  padding: 15px 25px
  color: #001F33

  .compare-flats-detail
    font-size: 14px

  @media (max-width: $md)
    right: auto
    left: 0
    bottom: 0
    width: 100%

  .small-text
    font-size: 16px

  a
    color: #001F33
    padding-right: 20px
    position: relative

    &:after
      content: ""
      width: 10px
      height: 14px
      background: url('../assets/icons/arr-dark.svg') no-repeat
      background-size: contain
      position: absolute
      right: 0
      top: 5px

  .compareNum
    background: var(--blue)
    position: absolute
    right: -6px
    top: -6px
    color: #ffffff
    width: 24px
    height: 24px
    border-radius: 50%
    text-align: center

.slider-for
  margin-bottom: 15px

  @media (max-width: $md)
    margin-bottom: 5px

  .slick-slide
    margin: 0

.slider-nav
  .slide
    cursor: pointer
    position: relative

    &:hover
      &:before
        content: ""
        width: 100%
        height: 100%
        position: absolute
        top: 0
        left: 0
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4))

      &:after
        content: ""
        width: 22px
        height: 22px
        position: absolute
        left: 50%
        top: 50%
        transform: translate(-50%, -50%)
        background: url(../assets/icons/plus.svg) no-repeat
        background-size: contain


.buttons
  width: 100%

  .hypo-calc
    &:hover
      background: #7CB6D9
      color: #001F33

  button
    width: 100%
.flat-image
  position: relative
  background: #Fff

  &.nove-bloky
    overflow: hidden

    img
      transform: scale(1.4)

  .pdf-button,
  .virtual-button
    width: 49px
    height: 49px
    background: #7CB6D9
    border: none
    position: absolute
    bottom: 20px
    left: 20px
    margin: 0
    transition: none

    @media (max-width: $md)
      left: 10px
      bottom: 10px

    &:before
      content: ""
      width: 25px
      height: 30px
      background: url('../assets/icons/pdf-icon.svg') no-repeat
      background-size: contain
      position: absolute
      left: 50%
      top: 50%
      transform: translate(-50%, -50%)

    &:hover
      background: #CFEDFF
      box-shadow: 0px 20px 48px rgba(0, 0, 0, 0.3)

      &:before
        background: url('../assets/icons/pdf-icon-hover.svg') no-repeat
        background-size: contain

  .virtual-button
    left: 65px

    @media (max-width: $md)
      left: auto
      right: 10px
      bottom: auto
      top: 10px

    &::before
      width: 33px
      height: 19px
      background: url('../assets/icons/360.svg') no-repeat
      background-size: contain

    &:hover
      &::before
        background: url('../assets/icons/360.svg') no-repeat
        background-size: contain
        
.tab-standard
  @media (max-width: $md)
    margin-left: -15px
    margin-right: -15px

#standards-slider
  max-width: 100%
  overflow: hidden
  .slide
    position: relative

    img
      width: 100%
  .novy-dvor
    .slide-1
      .standards-info
        .button-toggle
          &.info-1
            left: 22%
            top: 82%
          &.info-2
            left: 16%
            top: 33%
          &.info-3
            left: 16%
            top: 43%
          &.info-4
            left: 68%
            top: 24%
    .slide-2
      .standards-info
        .button-toggle
          &.info-2-1
            left: 42%
            top: 65%
          &.info-2-2
            left: 92%
            top: 30%
          &.info-2-3
            left: 53%
            top: 48%
          &.info-2-4
            left: 61%
            top: 48%
    .slide-3
      .standards-info
        .button-toggle
          &.info-3-1
            left: 55%
            top: 87%
          &.info-3-2
            left: 25%
            top: 20%
          &.info-3-3
            left: 50%
            top: 20%
    .slide-4
      .standards-info
        .button-toggle
          &.info-4-1
            left: 40%
            top: 40%
    .slide-5
      .standards-info
        .button-toggle
          &.info-5-1
            left: 55%
            top: 50%
          &.info-5-2
            left: 22%
            top: 45%
  .nadvorie
    .slide-1
      .standards-info
        .button-toggle
          &.info-1
            left: 12%
            top: 72%
          &.info-2
            left: 96%
            top: 73%
          &.info-3
            left: 73%
            top: 26%
          &.info-4
            left: 68%
            top: 24%
    .slide-2
      .standards-info
        .button-toggle
          &.info-2-1
            left: 16%
            top: 10%
          &.info-2-2
            left: 14%
            top: 65%
          &.info-2-3
            left: 65%
            top: 42%
          &.info-2-4
            left: 61%
            top: 48%
    .slide-3
      .standards-info
        .button-toggle
          &.info-3-1
            left: 80%
            top: 47%
          &.info-3-2
            left: 90%
            top: 60%
          &.info-3-3
            left: 10%
            top: 95%
    .slide-4
      .standards-info
        .button-toggle
          &.info-4-1
            left: 55%
            top: 14%
          &.info-4-2
            left: 20%
            top: 50%
          &.info-4-3
            left: 45%
            top: 67%
    .slide-5
      .standards-info
        .button-toggle
          &.info-5-1
            left: 70%
            top: 20%
          &.info-5-2
            left: 80%
            top: 54%
          &.info-5-3
            left: 40%
            top: 81%
  .na-hradzi
    .slide-1
      .standards-info
        .button-toggle
          &.info-1
            left: 8%
            top: 80%
          &.info-2
            top: auto
            bottom: 3%
            left: 56%
          &.info-3
            top: 30%
            left: 90%
    .slide-2
      .standards-info
        .button-toggle
          &.info-2-1
            left: 23%
            top: 25%
          &.info-2-2
            top: auto
            bottom: 25%
            left: 22%
          &.info-2-3
            top: 12%
            left: 38%
    .slide-3
      .standards-info
        .button-toggle
          &.info-3-1
            left: 62%
            top: 40%
          &.info-3-2
            top: 58%
            left: 62%
          &.info-3-3
            top: 50%
            left: 95%
    .slide-4
      .standards-info
        .button-toggle
          &.info-4-1
            left: 21%
            top: auto
            bottom: 15%
          &.info-4-2
            top: auto
            bottom: 10%
            left: 48%
          &.info-4-3
            top: auto
            bottom: 18%
            left: 80%
    .slide-5
      .standards-info
        .button-toggle
          &.info-5-1
            left: 43%
            top: 50%
          &.info-5-2
            top: auto
            bottom: 20%
            left: 52%

.novy-dvor
  .slide-1
    .standards-info
      .box
        &.box-1
          top: 0px
          left: 50px
        &.box-2
          top: auto
          bottom: 50px
          left: -160px
        &.box-3
          top: 50px
          left: -160px
          bottom: auto
        &.box-4
          top: 50px
          left: -160px
          bottom: auto

          @media (max-width: $md)
            top: 0!important
            left: 35px !important
  .slide-2
    .standards-info
      .box
        &.box-1
          right: 50px
          top: -30px
        &.box-2
          right: 50px
          bottom: -50px
        &.box-3
          right: 50px
          bottom: 0px
        &.box-4
          left: 0
          top: 50px
  .slide-3
    .standards-info
      .box
        &.box-1
          left: -160px
          bottom: 50px
        &.box-2
          left: -160px
          top: 50px
        &.box-3
          left: -160px
          top: 50px
  .slide-4
    .standards-info
      .box
        &.box-1
          left: -160px
          top: 50px
  .slide-5
    .standards-info
      .box
        &.box-1
          left: -160px
          top: 50px
        &.box-2
          left: -160px
          top: 50px
.nadvorie
  .slide-1
    .standards-info
      .box
        &.box-1
          top: auto
          bottom: 0
          left: 50px
        &.box-2
          top: 50px
          bottom: auto
          right: 0
        &.box-3
          top: 0
          right: 50px
          bottom: auto
        &.box-4
          top: 50px
          left: -160px
          bottom: auto

          @media (max-width: $md)
            top: 0!important
            left: 35px !important
  .slide-2
    .standards-info
      .box
        &.box-1
          left: 50px
          top: -30px
        &.box-2
          left: 0
          top: 50px
        &.box-3
          right: 50px
          top: 50px
          left: -160px
        &.box-4
          left: 0
          top: 50px
  .slide-3
    .standards-info
      .box
        &.box-1
          left: -160px
          bottom: 50px
        &.box-2
          right: 0
          top: 50px
        &.box-3
          left: 0
          bottom: 50px
  .slide-4
    .standards-info
      .box
        &.box-1
          left: -160px
          top: 50px
        &.box-2
          left: -160px
          top: 50px
        &.box-3
          left: 50px
          top: 0
  .slide-5
    .standards-info
      .box
        &.box-1
          left: -160px
          top: 50px
        &.box-2
          left: -160px
          top: 50px
        &.box-3
          right: 50px
          bottom: 0
.na-hradzi
  .slide-1
    .standards-info
      .box
        &.box-1
          top: -160px
          left: 50px
        &.box-2
          top: auto
          bottom: 50px
          left: -160px
        &.box-3
          top: 0
          left: auto
          right: 50px
  .slide-2
    .standards-info
      .box
        &.box-1
          top: 50px
          right: -160px
        &.box-2
          top: 0
          left: 50px
        &.box-3
          top: 0
          left: 50px
  .slide-3
    .standards-info
      .box
        &.box-1
          bottom: 0
          left: auto
          right: 50px
        &.box-2
          top: 0
          left: auto
          right: 50px
        &.box-3
          bottom: 0
          left: auto
          right: 50px
  .slide-4
    .standards-info
      .box
        &.box-1
          top: auto
          bottom: 55px
          left: -160px
        &.box-2
          top: auto
          bottom: 55px
          left: -160px
        &.box-3
          top: auto
          bottom: 55px
          left: -160px
  .slide-5
    .standards-info
      .box
        &.box-1
          top: auto
          bottom: 0
          left: 55px
        &.box-2
          top: -100px
          left: auto
          right: 55px

          @media (max-width: $md)
            top: 0!important
            left: 35px !important
.standards-info
  .box
    display: none
    position: absolute
    background: rgba(255, 255, 255, .8)
    width: 370px
    box-shadow: 0px 15px 40px rgba(112, 144, 176, 0.4)

    @media (max-width: $md)
      left: 30px !important
      top: 30px !important
      bottom: auto !important
      right: auto !important
      width: 80vw
      background: #fff

    &.show
      display: block

    h4, p
      color: var(--darkBlue)

    h4
      font-size: 18px
      font-weight: bold

      @media (max-width: $md)
        text-transform: capitalize

    p
      margin-bottom: 0
      font-size: 16px

      @media (max-width: $md)
        font-size: 14px
        line-height: 21px
        -webkit-font-smoothing: none
  .button-toggle
    position: absolute
    width: 44px
    height: 44px
    background: var(--blue)
    top: 50%
    left: 50%
    transform: translate(-50%, -50%) rotate(360deg)
    border-radius: 50%
    cursor: pointer
    z-index: 100
    box-shadow: 0px 15px 40px rgba(112, 144, 176, 0.4)
    transition: 0.8s cubic-bezier(0.2, 0.6, 0.3, 1.1)

    @media (max-width: $md)
      width: 32px
      height: 32px

  .button-toggle:after
    content: ''
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    height: 2px
    width: 50%
    background: white

    @media (max-width: $md)
      height: 1px

  .button-toggle:before
    content: ''
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    height: 50%
    width: 2px
    background: white

    @media (max-width: $md)
      width: 1px

  .button-toggle.clicked
    //transform: translate(-50%, -50%) rotate(180deg)
    background: var(--textDark)
    @media (max-width: $md)
      left: 25px !important
      top: 25px !important
      bottom: auto !important
      right: auto !important

      & ~ .button-toggle
        display: none

  .button-toggle.clicked:before
    width: 0

.small-font
  font-size: 14px
.btn-outline-primary
  color: #7CB6D9
  border: 1px solid #7CB6D9
  padding-top: 10px
  padding-bottom: 10px
.left-line
  position: relative
  &:before
    content: ""
    width: 2px
    height: 85%
    background: var(--primary)
    position: absolute
    left: 0
    top: 50%
    transform: translateY(-50%)
  .item
    position: relative
    border-bottom: 1px solid rgba(255, 255, 255, 0.2)
    margin-left: 60px
    @media (max-width: $md)
      margin-left: 20px
    &:before
      content: ""
      width: 36px
      height: 36px
      background: var(--primary)
      position: absolute
      left: -92px
      top: 50%
      transform: translateY(-50%)
      border-radius: 50%
      border: 3px solid #001F33

      @media (max-width: $md)
        left: -51px

    .num
      position: absolute
      left: -78px
      top: 50%
      transform: translateY(-50%)
      font-size: 14px
      color: #001F33

      @media (max-width: $md)
        left: -37px
.finance
  .box-wrapper
    @media (max-width: $md)
      flex-direction: column

    &.price
      h4
        font-size: 60px
  .box
    border: 1px solid rgba(255, 255, 255, 0.1)
    width: 260px
    height: 260px
    display: flex
    align-items: center
    justify-content: center
    flex-direction: column
    padding: 25px
    text-align: center

    @media (max-width: $md)
      width: 100%
      height: auto
      margin-bottom: 15px

    h4
      font-size: 76px
      font-weight: 800
      color: var(--primary)

      span
        font-size: 32px
        font-weight: 300

  .contact
    .name
      font-size: 18px
      font-weight: 500

    a
      color: var(--primary)
  p
    font-size: 16px
    font-weight: 400
.hypo
  p
    margin-bottom: 0

    a
      color: #fff
      font-size: 16px
.flat-info
  @media (max-width: $md)
    order: 2
  h3
    padding-top: 27px
    margin-bottom: 41px
.hypokalkulacka
  width: 300px
  margin: auto
  display: block
  height: 285px
  overflow: hidden
.font-large
  font-size: 26px
.flatDetail
  padding-top: 120px
  padding-bottom: 50px
  background: var(--darkBlue)

  @media (max-width: $md)
    padding-top: 90px

.sample
  background: var(--textBright)

  @media (max-width: $md)
    padding: 15px 0

  .category
    color: var(--primary)
    font-size: 16px
    font-weight: 600
    margin-bottom: 30px

    @media (max-width: $md)
      margin-bottom: 15px

  h3
    font-size: 40px
    line-height: 45px
    font-weight: 400
    margin-bottom: 20px

    @media (max-width: $md)
      font-size: 28px
      line-height: 32px

  p
    font-size: 16px
    margin-bottom: 40px
    line-height: 150%
</style>